(function($, window, undefined) {
  if (window.mg === undefined)
    window.mg = {};

  if (window.mg.ui === undefined)
    window.mg.ui = {};

  const _ = window.mg;

  const defaults = {
    nextFocus : null
  };

  class GolfId {
    constructor(input, options) {
      this._$input  = $(input);
      this._options = $.extend({}, defaults, options);

      return this._$input.data('ui.golfid') || this.init();
    }

    init() {
      if (this._$input.data('ui.golfid'))
        return this;

      let option = {
        blocks      : [6, 3],
        delimiter   : '-',
        numericOnly : true
      };

      if (this._options.nextFocus) {
        option.onValueChanged = (e) => {
          const $nextFocus = $(this._options.nextFocus);

          if ($nextFocus.length && /^\d{6}-\d{3}$/.test(e.target.value))
            $nextFocus.focus();
        };
      }

      this._cleave = new Cleave(this._$input, option);
      this._$input.data('ui.golfid', this);

      _.ui.clearer(this._$input);

      return this;
    }

    destroy() {
      return GolfId.destroy(this._$input);
    }

    static destroy(input) {
      const $input   = $(input);
      const instance = $input.data('ui.golfid');

      if (!instance)
        console.warn('The golfid is not initialised');

      _.ui.clearer.destroy(instance._$input);

      instance._cleave.destroy();
      instance._$input.removeData('ui.golfid');

      return instance;
    }
  }

  _.ui.golfId         = (input, options) => new GolfId(input, options);
  _.ui.golfId.destroy = (input) => GolfId.destroy(input);
})(jQuery, window);